import { ReactElement, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useAIChatFindingsStore, { type SceneFinding } from 'src/state/stores/aiChatFindings'
import { countLabel } from '../utils'
import SceneOverlayChip from './SceneOverlayChip'

const NO_FINDINGS: SceneFinding[] = []

/**
 * How many findings of a check the agent shows in the scene (`show_findings`), per severity and
 * element; a click hides or shows them, the x removes them. Shown only while there are some.
 */
const SceneFindingsChip = (): ReactElement | null => {
  const { projectId } = useParams()
  const findings = useAIChatFindingsStore(state =>
    projectId ? state.findingsByProject[projectId] ?? NO_FINDINGS : NO_FINDINGS,
  )
  const hidden = useAIChatFindingsStore(state =>
    projectId ? state.hiddenByProject[projectId] ?? false : false,
  )
  const setFindings = useAIChatFindingsStore(state => state.setFindings)
  const toggleHidden = useAIChatFindingsStore(state => state.toggleHidden)
  const label = useMemo(() => countLabel(findings), [findings])

  if (!projectId || findings.length === 0) return null

  return (
    <SceneOverlayChip
      label={`Befunde in der Szene: ${label}`}
      hidden={hidden}
      onToggleHidden={() => toggleHidden(projectId)}
      onRemove={() => setFindings(projectId, [])}
      data-cy="ai-chat-scene-findings"
    />
  )
}

export default SceneFindingsChip
